<template>
  <b-row>
    <b-card class="col-12">
      <b-row>
        <b-col cols="12">
          <b-form-group
              label="Vorlage"
              label-cols="8"
          >
            <v-select
                v-model="template"
                :options="templates"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>


    <b-card class="col-12">
      <b-row>
        <b-col cols="12">
          <b-form-group
              label="Reisetag"
              label-for="Reisetag"
              prepend="@"
              class="input-group-merge"
              size="sm"
          >
            <b-input-group
                prepend="Datum"
                class="input-group-merge"
                size="sm"
            >
              <cleave
                  id="date"
                  v-model="receipt.Date"
                  class="form-control form-control-sm"
                  :raw="false"
                  :options="options.date"
                  placeholder="DD.MM.YYYY"
                  ref="Date"
                  @keyup.enter.native="NextInput('CashEuroFieldAmount')"
                  @keyup.native="NumberOnlyAndAddDay($event)"
                  size="sm"
                  tabindex="19"
              />
              <template #append>
                <b-form-datepicker
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    button-only
                    :start-weekday="1"
                    locale="de-DE"
                    color="danger"
                    size="sm"
                    @context="onDateFromContext"
                />
              </template>

            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
              label="Belegnummer"
              label-for="number"
          >
            <b-form-input
                id="number"
                v-model="receipt.Number"
                class="form-control-sm"
                placeholder="Belegnummer"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
              label="Kategorie"
              label-for="categorie"
          >
            <b-form-input
                v-model="receipt.Category"
                id="categorie"
                class="form-control-sm"
                placeholder="Kategorie"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
              label="Aussteller-Name"
              label-for="SupplierName"
          >
            <b-form-input
                v-model="receipt.SupplierName"
                id="SupplierName"
                class="form-control-sm"
                placeholder="SupplierName"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="Brutto"
              label-for="gross"
          >

            <euro-field ref="CashEuroFieldAmount" @keyup.enter.native="NextInput('Finish')"/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
              label="Mwst"
              label-for="tax"
          >

            <b-form-input
                v-model="receipt.Tax"
                id="tax"
                class="form-control-sm"
                placeholder="SupplierName"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="col-12">
      <b-row>
        <b-button class="btn-block btn-success" @click="CreateSevdeskVoucher">Anlegen</b-button>
      </b-row>
    </b-card>
  </b-row>
</template>

<script>
import Cleave from 'vue-cleave-component'

import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BAlert, VBTooltip, BFormDatepicker,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem, BSpinner, BCardBody, BCard, BCardHeader, BCollapse,

} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ConnectedVoucherBadge from '@/views/extras/ConnectedVoucherBadge.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import EuroField from '@/views/voucher2/EuroFild.vue'

export default {
  components: {
    EuroField,
    vSelect,
    BCollapse,
    BCardHeader,
    BCard,
    BCardBody,
    ConnectedVoucherBadge,
    BTable,
    BAvatar,
    BAlert,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BFormDatepicker,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
    BSpinner,
    Cleave
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {

      options: {
        Time2Label: 'Abflug',
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'Y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
        number: {
          numericOnly: true,
          blocks: [16],
          delimiters: ['']
        },

      },
      receipt: {
        Number: 0,
        Date: '',
        Gross: 0,
        Tax: 19,
        SupplierName: '',
        Category: ''
      },
      template: 'Frei',
      templates: ['Frei', 'Tankbeleg', 'Tankbeleg Star', 'Tankbeleg Aral', 'Waschbeleg', 'Flughafen', 'Taxi', 'Porto', 'Büro', 'Sonstige KFZ-Kosten', 'Autoteile Nentwig'],
      templateData: [
        {
          name: 'Frei',
          category: '',
          supplierName: '',
          gross: 0.00,
          tax: 19,

        },
        {
          name: 'Tankbeleg',
          category: 'Benzin',
          supplierName: 'Tankstelle',
          gross: 0.00,
          tax: 19,

        },
        {
          name: 'Tankbeleg Star',
          category: 'Benzin',
          supplierName: 'Star Tankstelle',
          gross: 0.00,
          tax: 19,

        },
        {
          name: 'Tankbeleg Aral',
          category: 'Benzin',
          supplierName: 'Aral Tankstelle',
          gross: 0.00,
          tax: 19,

        },
        {
          name: 'Waschbeleg',
          category: 'Wagenpflege',
          supplierName: 'Waschbär',
          gross: 0.00,
          tax: 19,

        },
        {
          name: 'Flughafen',
          category: 'Stellplatz/Garagenmiete',
          supplierName: 'Flughafen',
          gross: 50.00,
          tax: 19,

        },
        {
          name: 'Taxi',
          category: 'Taxi',
          supplierName: 'Taxi',
          gross: 0.00,
          tax: 7,

        },
        {
          name: 'Porto',
          category: 'Porto',
          supplierName: 'Deutsche Post',
          gross: 0.00,
          tax: 0,

        },
        {
          name: 'Büro',
          category: 'Bürobedarf',
          supplierName: '',
          gross: 0.00,
          tax: 0,

        },
        {
          name: 'Sonstige KFZ-Kosten',
          category: 'Sonstige KFZ-Kosten',
          supplierName: '',
          gross: 0.00,
          tax: 19,

        },
        {
          name: 'Autoteile Nentwig',
          category: 'Inspektion/Reparatur',
          supplierName: 'Autoteile Nentwig',
          gross: 0.00,
          tax: 19,

        },
      ]

    }
  },
  computed: {},
  mounted() {
    this.$nextTick(() => {
      document.title = 'Sevdesk Voucher'
    })
    this.getNextCount()
    this.$watch(
        () => this.template,
        val => {
          let found = null
          Object.keys(this.templateData)
              .forEach(key => {
                console.log(this.templateData[key])

                this.$nextTick(() => this.$refs.Date.$el.select())

                if (this.templateData[key].name == val) {
                  found = this.templateData[key]
                }
              })
          if (found != null) {
            console.log(found)
            this.receipt.Category = found.category
            this.receipt.SupplierName = found.supplierName
            this.receipt.Tax = found.tax
            if (found.gross) {
              this.$nextTick(() =>
                  this.$refs.CashEuroFieldAmount.Set(found.gross)
              )

            }
          }
        },
    )
  },
  methods: {
    Reset() {
      let old = this.template
      this.receipt = {
        Number: 0,
        Date: '',
        Gross: 0,
        Tax: 19,
        SupplierName: '',
        Category: ''
      }
      this.$nextTick(() =>

          this.$refs.CashEuroFieldAmount.Set(0)
      )
      this.$nextTick(() => {

            this.template = 'Frei'
            this.$nextTick(() =>
                this.template = old
            )
          }
      )
      this.getNextCount()
    },
    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.vData.TravelDay = ctx.activeFormatted
      }
    },
    NextInput(input) {
      if (input == 'CashEuroFieldAmount') {
        this.$nextTick(() => this.$refs.CashEuroFieldAmount.Focus())
      }

      if (input == 'Finish') {
        this.$nextTick(() => this.$refs.CashEuroFieldAmount.Blur())
        this.$nextTick(() => {
          setTimeout(() => {
            this.CreateSevdeskVoucher()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Info',
                icon: 'CheckIcon',
                text: 'Eintrag wird erfasst.',
                variant: 'warning',
              },
            })
          }, 500)
        })
        // SAVE
      }
    },
    NumberOnlyAndAddDay(ev) {
      const isNumber = /^[0-9]$/i.test(ev.key)
      if (ev.key == '+' || ev.key == '-') {
        const date = this.receipt.Date.split('.')
        if (date[0].length == 2 && date[1].length == 2 && date[2].length == 2) {
          let TravelDay = new Date('20' + date[2] + '-' + date[1] + '-' + date[0])
          if (ev.key == '+') {
            TravelDay.setDate(TravelDay.getDate() + 1)
          }
          if (ev.key == '-') {
            TravelDay.setDate(TravelDay.getDate() - 1)
          }

          this.receipt.Date = new Date(TravelDay).toLocaleString('de-DE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              },
          )

        }
      }
      return false
    },
    CreateSevdeskVoucher() {
      this.receipt.Gross = this.$refs.CashEuroFieldAmount.fieldData
      // Gegebenes Datum im Format "20.12.23"
      const dateString = this.receipt.Date

      // Parsen des Datums mit Jahr, Monat und Tag
      const parts = dateString.split('.')
      const day = parts[0]
      const month = parts[1]
      let year = parts[2]
      // Falls das Jahr weniger als 100 ist, füge "20" am Anfang hinzu, um das Jahr zu vervollständigen
      if (year < 100) {

        console.log(year)
        year = '20' + year

        console.log(year)
      }

      // Neues Datum im gewünschten Format erstellen: "20.12.2023"
      this.receipt.Date = day + '.' + month + '.' + year

      const id = this.receipt.Number
      this.$http.post('/taxoffice/create/sevdeskvoucher', JSON.stringify(this.receipt))
          .then(resp => {
            if (resp.data.success) {
              this.Reset()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Eintrag (' + id + ') wurde erfasst.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    ReplaceGross() {
      console.log('x')
      this.receipt.Gross = this.receipt.Gross.replace('.', ',')
    },
    getNextCount() {
      this.$http.get('taxoffice/get/next/count')
          .then(resp => {
            this.receipt.Number = resp.data.count
            console.log(resp)
          })
          .catch(err => {
            console.error(err)
          })
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
